

const onMenuDropToggleMouseover = (e) => {
  const trigger = e.currentTarget.querySelector('a[data-bs-toggle]')
  if (!trigger?.classList.contains("show")) {
    trigger.click()
  }
}
const onMenuDropToggleMouseout = (e) => {
  const trigger = e.currentTarget.querySelector('a[data-bs-toggle]')
  if (trigger?.classList.contains("show")) {
    trigger.click()
  }
}

export const initHeaderDropdown = () => {
  $("body").on("mouseover", ".header-main .main-menu li.dropdown", onMenuDropToggleMouseover)
  $("body").on("mouseout", ".header-main .main-menu li.dropdown", onMenuDropToggleMouseout)
}